var React = require('react');

function Comment (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#414B7C","fillRule":"nonzero"},[React.createElement("path",{"d":"M15.2 2.8v10.7l-1.7-1.8H2.8v-9h12.4zM2.6 1C1.7 1 1 1.7 1 2.6v9.2c0 1 .7 1.6 1.6 1.6h10.9L17 17V2.6c0-.9-.7-1.6-1.6-1.6H2.6z","key":0}),React.createElement("path",{"d":"M13.4 5H4v1.8h9.4zM13.4 8H4v1.8h9.4z","key":1})]));
}

Comment.defaultProps = {"viewBox":"0 0 18 18"};

module.exports = Comment;

Comment.default = Comment;



//////////////////
// WEBPACK FOOTER
// ./src/icons/comment.svg
// module id = 796
// module chunks = 0